module.exports = __webpack_public_path__ + "static/media/Hair.fddfc21a.png";